import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import { chain, SetUserFields } from "@insite/client-framework/Store/Pages/UserSetup/Handlers/SetUserFields";

addToChainAfter(chain, SetUserFields, props => {
    const updatedUser = props.result.updatedUser;

    if (!updatedUser) {
        return;
    }

    const parameter: any = props.parameter;
    if (typeof parameter.policies !== "undefined") {
        (updatedUser as any).properties = {
            ...((updatedUser as any).properties),
            policies: parameter.policies,
        };
    }
});
